import { triggerModeValues } from '../constants'

export const exchangeTriggerModeOptions = [
  { label: 'Crear el pedido cuando ocurra este trigger', value: triggerModeValues.atTrigger },
  { label: 'Retrasar un número específico de días', value: triggerModeValues.delayByDays },
]
